var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"color":"secondary","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticStyle:{"cursor":"pointer"}},'v-icon',attrs,false),on),[_vm._v("save_alt")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('dashboard.download')))])])}
var staticRenderFns = []

export { render, staticRenderFns }